<section class="page__section -small-bottom">
    <timeline></timeline>
</section>
